import { addDays, differenceInCalendarDays } from "date-fns";
import { DECORACOES } from "@/data/acomodacoes";

export const PEAK_FEE = 500;
export const PET_FEE = 200;
const PEAK = ["12-24", "12-25", "12-31", "01-01"];

export const isPeak = (d) => PEAK.includes(`${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`);

export const brl = (v) => (v ?? 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export function calcular(preco, range, pet, decoracaoId) {
  const from = range?.from;
  const to = range?.to;
  const noites = from && to ? Math.max(0, differenceInCalendarDays(to, from)) : 0;
  let especiais = 0;
  for (let i = 0; i < noites; i++) if (isPeak(addDays(from, i))) especiais++;
  const subtotal = noites * preco;
  const decoracao = DECORACOES.find((d) => d.id === decoracaoId) ?? null;
  const total = noites ? subtotal + especiais * PEAK_FEE + (pet ? PET_FEE : 0) + (decoracao?.preco ?? 0) : 0;
  return { noites, especiais, subtotal, total, decoracao };
}

export const validarCPF = (cpf) => {
  const c = cpf.replace(/\D/g, "");
  if (c.length !== 11 || /^(\d)\1+$/.test(c)) return false;
  const dig = (n) => {
    let s = 0;
    for (let i = 0; i < n; i++) s += Number(c[i]) * (n + 1 - i);
    const r = (s * 10) % 11;
    return r === 10 ? 0 : r;
  };
  return dig(9) === Number(c[9]) && dig(10) === Number(c[10]);
};

export const maskCPF = (v) =>
  v.replace(/\D/g, "").slice(0, 11).replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2");

export const maskPhone = (v) => {
  const d = v.replace(/\D/g, "").slice(0, 11);
  if (d.length <= 2) return d;
  if (d.length <= 7) return `(${d.slice(0, 2)}) ${d.slice(2)}`;
  return `(${d.slice(0, 2)}) ${d.slice(2, d.length - 4)}-${d.slice(-4)}`;
};
